import React from "react";

// Stroke-based "people/group" line icon. The old version used a hard-coded grey
// fill plus transparent decoy paths that the sidebar's forced icon stroke turned
// into an odd white outline box. All paths now, so it colours cleanly white like
// the rest of the nav. Used by Team Schedule, Visitors and Contractors.
const Visitors = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Front person */}
        <path
          d="M9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M16 21V19C16 16.79 14.21 15 12 15H6C3.79 15 2 16.79 2 19V21"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        {/* Second person (behind) */}
        <path
          d="M16 4.13C17.72 4.57 18.99 6.13 18.99 8C18.99 9.87 17.72 11.43 16 11.87"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M22 21V19C21.99 17.32 20.86 15.9 19.3 15.45"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default Visitors;
